"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/surface";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="app-page flex min-h-[65vh] items-center justify-center">
      <EmptyState
        className="w-full max-w-2xl border-destructive/25"
        title="This view could not load"
        description="Your data has not been changed. Try the view again; if the problem continues, return to the dashboard."
        action={<Button onClick={reset}>Try again</Button>}
      />
    </div>
  );
}
